exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description {\n  word-break: break-word; }\n\n:host /deep/ .dialog-room-note-description .description {\n  word-break: break-word;\n  font-size: 14px;\n  line-height: 16px;\n  color: #061021; }\n  :host /deep/ .dialog-room-note-description .description ul {\n    padding-inline-start: 15px; }\n  :host /deep/ .dialog-room-note-description .description li {\n    list-style-type: disc; }\n  :host /deep/ .dialog-room-note-description .description p {\n    margin: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-room-note-description/dialog-room-note-description.component.scss
// module id = 931
// module chunks = 22